/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
(function() {
  App.array_field_button_click_handler = function(event) {
    var $button = $(this);
    var array_input_selector = '[data-type="array-input"]';
    var array_element_selector = '[data-type="array-element"]';

    var $array_input = $button.closest(array_input_selector);
    var $array_elements = $array_input.find(array_element_selector);

    var template = $("#" + $array_elements.first().data().template).text();

    switch ($button.data().action) {
      case "add":
        $array_elements.last().after(template);
        break;
      case "remove":
        var $array_element = $button.closest(array_element_selector);
        if ($array_elements.length === 1) {
          $array_elements.after(template);
        }
        $array_element.remove();
        break;
    }
    return true;
  };
  return $(document).on(
    "click",
    ".array-input button",
    { asdf: "qwer" },
    App.array_field_button_click_handler
  );
}.call(this));
